import { Col, Row } from "antd";
import { isUndefined } from "lodash";
import { useMemo } from "react";
import { MdArrowForward } from "react-icons/md";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import Select from "../Components/Select";

function View({ onNext, branches, selectedBranch, setSelectedBranch }) {
  const options = useMemo(
    () =>
      branches.map(({ name }) => ({
        label: name,
        value: name,
      })),
    [branches],
  );

  return (
    <Layout>
      <Header
        title="Sélectionnez votre collectivité de rattachement pour<br />commencer"
        highlight="collectivité de rattachement"
        subtitle="Choix de la collectivité"
      />

      <Row justify="center">
        <Col xs={24} md={18} lg={8}>
          <div className="grid--1">
            <Select
              variant="simple"
              label={"Collectivité"}
              value={selectedBranch}
              placeholder={"Sélectionnez ..."}
              options={options}
              onChange={setSelectedBranch}
              showSearch
              virtual={false}
            />
          </div>
        </Col>
      </Row>
      <ActionButtons
        onNext={onNext}
        disabled={isUndefined(selectedBranch)}
        icon={<MdArrowForward size={24} />}
        buttonText="Allons-y !"
      />
    </Layout>
  );
}

export default View;
